
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TemplateItemProps } from ".";
import { loading, endLoading } from "store/template";

interface ApiTemplateRemoveInputProps {
    ids: number[]
}

type ApiTemplateRemoveOutputProps = OutputBaseProps<{ item: TemplateItemProps; }>

export const apiTemplateRemove = async (data: ApiTemplateRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiTemplateRemoveOutputProps>("/api/template/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};